export default "__VITE_ASSET__DP71UONd__"